
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/new-year-new-site",
      function () {
        return require("private-next-pages/blog/new-year-new-site/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/new-year-new-site"])
      });
    }
  